import base from "./base/index"; // 接口域名列表
import axios from "../utils/http"; // 导入http中创建的axios实例
import utils from "../utils";
/**
 * 子系统
 */
const subsystem = {

  /**
   * 查询子系统
   */
  getSubsystems () {
    return axios.post(base.subsystem.getSubsystems)
  },
  /**
   * 设置子系统包含页面
   * @param {*} subsystemId 子系统id
   * @param {*} pages [pagePath,..] Json字符串
   * @returns 
   */
  setSubsystemContainingFrontEndPages (subsystemId, pages) {
    return axios.post(base.subsystem.setSubsystemContainingFrontEndPages, utils.postParamsArrayToJsonString({ subsystemId, pages }))
  },
  /**
   * 查询子系统包含页面
   * @param {*} subsystemId 子系统id
   * @returns 
   */
  getSubsystemContainingFrontEndPages (subsystemId) {
    return axios.post(base.subsystem.getSubsystemContainingFrontEndPages, utils.postParamsArrayToJsonString({ subsystemId }))
  },
  deleteSubsystemContainingFrontEndPages (subsystemId,pageId) {
    return axios.post('/api/deleteSubsystemContainingFrontEndPages', utils.postParamsArrayToJsonString({ subsystemId,pageId }))
  },
}

export default subsystem